import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalPreRoutingManipulationApiService {

  constructor(private http: HttpClient) {}

  readonly globalPreRoutingUrl: string = 'configuration/normalization';

  getGlobalPreRoutingManipulation(): Observable<any> {
    return this.http.get(this.globalPreRoutingUrl);
  }

  editGlobalPreRoutingManipulation(globalPreRoutingManipulationSettings): Observable<any> {
    return this.http.put(this.globalPreRoutingUrl, globalPreRoutingManipulationSettings);
  }
}
